import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { navigate } from "gatsby";

import Layout from "../layout";
import SEO from "../seo";

import Filters from "../search-results/filters";
import Pagination from "../search-results/pagination";
import ResultsList from "../search-results/results-list";
import ResultsMap from "../search-results/results-map";
import ExpandableFilters from "./expandable-filters";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompass } from "@fortawesome/free-solid-svg-icons";

const SearchContainer = ({
  listId,
  baseURL,
  location,
  title,
  initialPageInfo,
  initialProperties,
  initialFilters,
  initialPagination,
}) => {
  const {
    region,
    property_type,
    size,
    search,
    features,
    price,
    has_discounts,
    diamond_deal,
    page,
  } = queryString.parse(location.search);
  const [searchState, setSearchState] = useState({
    region: initialFilters?.region ? initialFilters.region[0] : region || "",
    property_type: initialFilters?.property_type
      ? initialFilters.property_type[0]
      : property_type || "",
    size: initialFilters?.size ? initialFilters.size : size || "",
    price: initialFilters?.price ? initialFilters.price : price || "",
    features: initialFilters?.features
      ? initialFilters.features
      : features || null,
    diamond_deal: initialFilters?.diamond_deal
      ? initialFilters.diamond_deal
      : diamond_deal || null,
    has_discounts: initialFilters?.has_discounts
      ? initialFilters.has_discounts
      : has_discounts || null,
    search: search || "",
    page: page || null,
  });

  const [isSearching, setIsSearching] = useState(
    !initialProperties || location.search.length > 0
  );

  const [propertyPages, setPropertyPages] = useState({
    isLoading: !isSearching && initialProperties ? false : true,
    propertyPages: !isSearching && initialProperties ? initialProperties : [],
    pageInfo: !isSearching && initialPageInfo ? initialPageInfo : null,
  });

  useEffect(() => {
    if (!isSearching) {
      return;
    }
    setPropertyPages({
      ...propertyPages,
      isLoading: true,
    });
    const fetchData = async () => {
      let filter = {};

      for (const key of Object.keys(searchState)) {
        if (
          searchState[key] !== "" &&
          searchState[key] !== null &&
          (!initialFilters || !initialFilters[key])
        ) {
          filter[key] = searchState[key];
        }
      }

      if (searchState.page) {
        filter.page = searchState.page;
      }
      window.history.pushState(
        {},
        document.title,
        (baseURL || "") + "?" + queryString.stringify(filter, { sort: false })
      );

      // FILTERS
      filter.paginate = true;
      filter.perPage = 10;
      if (listId) {
        filter.list = listId;
      }
      const response = await fetch(
        "https://www.gaia-travels.com/ajax/pages/search/?" +
          queryString.stringify(filter)
      );
      const result = await response.json();
      setPropertyPages({
        isLoading: false,
        propertyPages: result.nodes,
        pageInfo: result.pageInfo,
      });
    };
    fetchData();
  }, [searchState]);

  const handleSearchStateChange = search => {
    setIsSearching(true);
    setSearchState({
      ...searchState,
      ...search,
      page: null,
    });
  };

  const handleChangeDisabledFilters = search => {
    const state = {
      ...searchState,
      ...search,
      page: null,
    };
    console.log(state);
    const filter = {};
    for (const key of Object.keys(state)) {
      if (state[key] !== "" && state[key] !== null) {
        filter[key] = state[key];
      }
    }
    navigate("/search?" + queryString.stringify(filter, { sort: false }));
  };

  const handlePageChange = page => {
    if (isSearching) {
      setSearchState({
        ...searchState,
        page: page,
      });
    }
  };

  const makeLinkForPage = page => {
    if (initialPagination && !isSearching) {
      return initialPagination(page);
    } else {
      let filter = {};

      for (const key of Object.keys(searchState)) {
        if (
          searchState[key] !== "" &&
          searchState[key] !== null &&
          (!initialFilters || !initialFilters[key])
        ) {
          filter[key] = searchState[key];
        }
      }
      filter.page = page;
      return (
        window.location.pathname +
        "?" +
        queryString.stringify(filter, { sort: false })
      );
    }
  };
  let loadingIndicator;
  if (propertyPages.isLoading) {
    loadingIndicator = (
      <div
        className="results-list-spinner opacity-9"
        style={{
          position: "fixed",
          left: "0",
          right: "0",
          top: "0",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: "1021",
        }}
      >
        <FontAwesomeIcon
          icon={faCompass}
          pulse
          className="text-muted"
          fixedWidth
          size="6x"
        />
      </div>
    );
  }

  return (
    <Layout>
      <SEO title={title} />
      {loadingIndicator}
      <div className="container-fluid min-height-without-footer">
        <div className="row">
          <div className="col-lg-6 py-4 p-xl-4">
            <h2 className="mb-4">{title}</h2>
            <ExpandableFilters startCollapsed={!!initialFilters}>
              <Filters
                disabledFilters={initialFilters}
                search={searchState.search}
                region={searchState.region}
                property_type={searchState.property_type}
                size={searchState.size}
                price={searchState.price}
                features_values={searchState.features}
                has_discounts={searchState.has_discounts}
                diamond_deal={searchState.diamond_deal}
                onChange={handleSearchStateChange}
                onChangeDisabledFilters={handleChangeDisabledFilters}
                isLoading={propertyPages.isLoading}
              />
            </ExpandableFilters>
            <ResultsList
              isLoading={propertyPages.isLoading}
              properties={propertyPages.propertyPages}
              pageInfo={propertyPages.pageInfo}
            />
            <Pagination
              pageInfo={propertyPages.pageInfo}
              makeLinkForPage={makeLinkForPage}
              onPageChange={handlePageChange}
            />
          </div>
          <div className="col-lg-6 pb-5">
            <div className="navbar-height-top sticky-top">
              <ResultsMap
                isLoading={propertyPages.isLoading}
                properties={propertyPages.propertyPages}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SearchContainer;
